import AppStoreContext from 'contexts/AppStoreContext';
import ECSMapContext from 'contexts/ECSMapContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import DomElement from 'editor/components/DomElement';
import MapboxMarker from 'editor/components/map/MapboxMarker';
import MapboxRect from 'editor/components/map/MapboxRect';
import MarkerMarkupSync from 'editor/components/map/MarkerMarkupSync';
import Markup from 'editor/components/Markup';
import noop from 'lodash/noop';
import React, { FC, useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode;
  markupComp: Markup; // NOTE: Should this just accept a regular Markup Record?
};

const MarkupMarkerPortal: FC<Props> = (props: Props) => {
  const { markupComp, children } = props;

  const world = useContext(ECSWorldContext);
  const { map: mapComp } = useContext(ECSMapContext);
  const appStore = useContext(AppStoreContext);
  const [portal, setPortal] = useState<React.ReactPortal | null>(null);

  useEffect(() => {
    const { state: appState } = appStore;
    const pageid = markupComp.markup.fileid;
    const sheetVersion = appState.getSheetVersionByPageId(pageid);
    const msv = appStore.state.mappedSheetVersions.get(pageid);
    if (!msv) return noop;

    const sheetData = msv.imagesource?.calibrationconfig;
    if (!sheetData) return noop;

    const portalEl = document.createElement('div');
    const _portal = ReactDOM.createPortal(children, portalEl);
    setPortal(_portal);

    const mapRectComp = MapboxRect.fromImageAlignment(
      sheetData.corners,
      sheetVersion.width,
      sheetVersion.height
    );

    const _btnEntity = world
      .createEntity()
      .add(mapComp)
      .add(new MapboxMarker())
      .add(markupComp)
      .add(mapRectComp) // sheet coordinates
      .add(new DomElement(portalEl))
      .add(new MarkerMarkupSync());

    return () => {
      if (_btnEntity) {
        const _marker = _btnEntity.get(MapboxMarker);
        _marker.destroy = true; // lazily destroyed in manageMarker system.
      }
    };
  }, []);

  return portal;
};

export default MarkupMarkerPortal;
